(function () {
  if (window.__pcCustomInit) return;
  window.__pcCustomInit = true;

  // ===== PATTERN IMAGES (Mermaid / Leopard / Unicorn) =====
  window.PC_PATTERN_IMAGES = {
    'mermaid':           'https://cdn.shopify.com/s/files/1/0733/1735/1708/files/mermaid.avif?v=1780651650',
    'leopard':           'https://cdn.shopify.com/s/files/1/0733/1735/1708/files/leopard.avif?v=1780651650',
    'leopard print':     'https://cdn.shopify.com/s/files/1/0733/1735/1708/files/leopard.avif?v=1780651650',
    'unicorn':           'https://cdn.shopify.com/s/files/1/0733/1735/1708/files/unicorn.avif?v=1780651650',
    'rainbow':           'https://cdn.shopify.com/s/files/1/0733/1735/1708/files/unicorn.avif?v=1780651650',
    'unicorn rainbow':   'https://cdn.shopify.com/s/files/1/0733/1735/1708/files/unicorn.avif?v=1780651650',
    'unicorn & rainbow': 'https://cdn.shopify.com/s/files/1/0733/1735/1708/files/unicorn.avif?v=1780651650'
  };

  function pcGetPatternImage(name) {
    if (!name) return '';
    var clean = String(name).toLowerCase().trim()
      .replace(/^(ladies|womens|women|mens|men|kids|boys|girls|baby|babies|unisex)\s+/i, '')
      .replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!clean) return '';
    if (window.PC_PATTERN_IMAGES[clean]) return window.PC_PATTERN_IMAGES[clean];
    var keys = Object.keys(window.PC_PATTERN_IMAGES);
    for (var i = 0; i < keys.length; i++) {
      if (clean.indexOf(keys[i]) !== -1) return window.PC_PATTERN_IMAGES[keys[i]];
    }
    return '';
  }
  window.pcGetPatternImage = pcGetPatternImage;

  function pcFindWrapper(el) {
    if (!el || !el.closest) return null;
    return el.closest('.pc-card-wrapper');
  }
  function pcFindActionRow(wrapper) {
    return wrapper ? wrapper.querySelector('.pc-action-row') : null;
  }

  /* ============ SIZE DROPDOWN ============ */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.pc-size-dropdown-toggle');
    if (!toggle) return;
    e.preventDefault(); e.stopPropagation();
    var dropdown = toggle.closest('.pc-size-dropdown');
    var isOpen = dropdown.classList.contains('is-open');
    document.querySelectorAll('.pc-size-dropdown.is-open').forEach(function (d) {
      if (d !== dropdown) {
        d.classList.remove('is-open');
        var t = d.querySelector('.pc-size-dropdown-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
    if (isOpen) {
      dropdown.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      dropdown.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest('.pc-size-dropdown')) return;
    document.querySelectorAll('.pc-size-dropdown.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      var toggle = d.querySelector('.pc-size-dropdown-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.pc-size-dropdown.is-open').forEach(function (d) {
        d.classList.remove('is-open');
        var toggle = d.querySelector('.pc-size-dropdown-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ============ SIZE OPTION SELECT ============ */
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('.pc-size-option');
    if (!sizeBtn) return;
    if (sizeBtn.disabled || sizeBtn.classList.contains('is-sold-out')) return;
    e.preventDefault(); e.stopPropagation();
    var actionRow = sizeBtn.closest('.pc-action-row');
    if (!actionRow) return;
    actionRow.querySelectorAll('.pc-size-option').forEach(function (b) {
      b.classList.remove('is-selected');
      b.setAttribute('aria-selected', 'false');
    });
    sizeBtn.classList.add('is-selected');
    sizeBtn.setAttribute('aria-selected', 'true');
    var dropdown = sizeBtn.closest('.pc-size-dropdown');
    var toggle = dropdown.querySelector('.pc-size-dropdown-toggle');
    var label = dropdown.querySelector('.pc-size-dropdown-selected');
    var sizeName = sizeBtn.dataset.size || sizeBtn.querySelector('.pc-size-option-label').textContent;
    if (label) label.textContent = sizeName;
    dropdown.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }, true);

  /* ============ ATC BUTTON ============ */
  document.addEventListener('click', function (e) {
    var atcBtn = e.target.closest('.pc-atc-btn');
    if (!atcBtn) return;
    e.preventDefault(); e.stopPropagation();
    var actionRow = atcBtn.closest('.pc-action-row');
    var wrapper = pcFindWrapper(atcBtn);
    var selected = actionRow ? actionRow.querySelector('.pc-size-option.is-selected') : null;
    if (!selected) {
      var orig = atcBtn.textContent;
      atcBtn.textContent = 'Select a size';
      atcBtn.style.backgroundColor = '#c62828';
      setTimeout(function () { atcBtn.textContent = orig; atcBtn.style.backgroundColor = ''; }, 1500);
      return;
    }
    var variantId = selected.dataset.variantId;
    if (!variantId) return;
    atcBtn.classList.add('is-loading');
    atcBtn.textContent = 'Adding...';
    addToCart(variantId, atcBtn, wrapper, actionRow);
  }, true);

  /* ============ QUICK SHOP BUTTON ============ */
  document.addEventListener('click', function (e) {
    var qsBtn = e.target.closest('.pc-quick-shop-btn');
    if (!qsBtn) return;
    e.preventDefault(); e.stopPropagation();
    var handle = qsBtn.dataset.productHandle;
    if (!handle) return;
    if (window.PCQuickShopDrawer && typeof window.PCQuickShopDrawer.open === 'function') {
      window.PCQuickShopDrawer.open(handle);
    }
  }, true);

  /* ============ MIRROR SWATCHES FROM PRODUCT PAGE ============ */
  var __pcSwatchCache = {};
  var __pcFetchedCards = new WeakSet();

  var CACHE_KEY = 'pc_mirror_swatch_v8';
  try {
    localStorage.removeItem('pc_mirror_swatch_v2');
    localStorage.removeItem('pc_mirror_swatch_v3');
    localStorage.removeItem('pc_mirror_swatch_v4');
    localStorage.removeItem('pc_mirror_swatch_v5');
    localStorage.removeItem('pc_mirror_swatch_v6');
    localStorage.removeItem('pc_mirror_swatch_v7');
    var cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      var parsed = JSON.parse(cached);
      if (parsed && typeof parsed === 'object') {
        var now = Date.now();
        Object.keys(parsed).forEach(function (k) {
          if (parsed[k] && parsed[k]._ts && (now - parsed[k]._ts) < 3600000) {
            __pcSwatchCache[k] = parsed[k];
          }
        });
      }
    }
  } catch (e) {}

  function savePcCache() {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(__pcSwatchCache));
    } catch (e) {}
  }

  function fetchProductPageSwatches(handle) {
    if (__pcSwatchCache[handle]) {
      return Promise.resolve(__pcSwatchCache[handle]);
    }

    // Detect if we're in theme editor iframe (shopifyapps.com)
    var inThemeEditor = window.location.hostname.indexOf('shopifyapps.com') !== -1 ||
                        window.location.hostname.indexOf('shopifypreview.com') !== -1 ||
                        (window.Shopify && window.Shopify.designMode);

    var url;
    if (inThemeEditor) {
      // Use shop's actual domain
      var shopDomain = (window.Shopify && window.Shopify.shop) ||
                       document.querySelector('link[rel="canonical"]') ?
                         (document.querySelector('link[rel="canonical"]').href.match(/https?:\/\/([^\/]+)/) || [])[1] :
                       null;
      if (shopDomain) {
        url = 'https://' + shopDomain + '/products/' + handle;
      } else {
        url = '/products/' + handle;
      }
    } else {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      url = root.replace(/\/$/, '') + '/products/' + handle;
    }

    return fetch(url, {
      headers: { 'Accept': 'text/html' },
      mode: 'cors',
      credentials: 'omit'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var result = extractSwatchHtml(html, handle);
        __pcSwatchCache[handle] = { html: result.html, type: result.type, _ts: Date.now() };
        savePcCache();
        return __pcSwatchCache[handle];
      })
      .catch(function (err) {
        console.warn('[PC] Fetch failed for', handle, ':', err.message);
        return { html: '', type: 'error' };
      });
  }

  var CMAP = {
    // Basics
    'black':'#1a1a1a','white':'#f5f5f5','navy':'#1c2951','grey':'#9e9e9e',
    'gray':'#9e9e9e','beige':'#c8b89a','olive':'#708238','khaki':'#c3b17a',
    'sage':'#8fad88','tan':'#d2b48c','brown':'#795548','camel':'#c19a6b',
    'cream':'#fffdd0','ivory':'#f8f4e3','natural':'#f0ebe0','charcoal':'#4a4a4a',
    'stone':'#928e85','sand':'#c2b280','gold':'#c9a84c','floral':'#e8b4c8',
    'stripe':'#9e9e9e','print':'#a0a0a0','pink':'#f48fb1',
    'red':'#e53935','blue':'#1565c0','green':'#2e7d32','yellow':'#f9a825',
    'purple':'#6a1b9a','orange':'#e65100','coral':'#ff6f61','mint':'#98e4c9',
    'lilac':'#c8a2c8','rust':'#b7410e','denim':'#1560bd','ecru':'#ede9d0',
    // Moosel custom color names (single-word matchable)
    'ocean':'#14c4ea','blast':'#14c4ea',
    'avo':'#7cb342','smash':'#7cb342','avocado':'#7cb342',
    'pop':'#9c27b0','purple':'#9c27b0',
    'lime':'#9ccc65','twist':'#9ccc65',
    'tangerine':'#ff5722','sizzle':'#ff5722',
    'bubblegum':'#ff4081','bubble':'#ff4081','gum':'#ff4081',
    'cyan':'#00bfff','aqua':'#00bfff',
    'fuchsia':'#ff1493','magenta':'#ff1493',
    'turquoise':'#40e0d0','teal':'#008080',
    'emerald':'#50c878','jade':'#00a86b',
    'salmon':'#fa8072','peach':'#ffe5b4',
    'maroon':'#800000','burgundy':'#800020','wine':'#722f37',
    'mustard':'#ffdb58','amber':'#ffbf00','lemon':'#fff44f',
    'lavender':'#e6e6fa','violet':'#8f00ff','plum':'#8e4585',
    'chocolate':'#7b3f00','mocha':'#967259','caramel':'#af6e4d',
    'bronze':'#cd7f32','copper':'#b87333',
    'silver':'#c0c0c0','platinum':'#e5e4e2',
    'midnight':'#191970','royal':'#4169e1','cobalt':'#0047ab','sapphire':'#0f52ba',
    'forest':'#228b22','hunter':'#355e3b','army':'#4b5320',
    'rose':'#ff007f','blush':'#de5d83','dusty':'#b48b8b'
  };

  function getSwatchColor(str) {
    if (!str) return '';
    var s = String(str).toLowerCase()
      .replace(/^(ladies|womens|women|mens|men|kids|boys|girls|baby|babies|unisex)\s+/i, '')
      .replace(/[^a-z]/g, ' ').trim();
    if (!s) return '';
    // Try full string first
    if (CMAP[s]) return CMAP[s];
    var words = s.split(/\s+/);
    // Try multi-word combos (longest first)
    for (var len = words.length; len >= 1; len--) {
      for (var start = 0; start + len <= words.length; start++) {
        var combo = words.slice(start, start + len).join(' ');
        if (CMAP[combo]) return CMAP[combo];
      }
    }
    // Try individual words
    for (var wi = 0; wi < words.length; wi++) {
      if (CMAP[words[wi]]) return CMAP[words[wi]];
    }
    return '';
  }
  function buildBgStyle(imageUrl, color, title) {
    // PRIORITY 1: Pattern image (mermaid/leopard/unicorn)
    var patternImg = pcGetPatternImage(title);
    if (patternImg) {
      return 'background-image: url(\'' + patternImg + '\'); background-size: cover; background-position: center;';
    }

    // PRIORITY 2: Custom Groupmate swatch image (if present)
    if (imageUrl && imageUrl.indexOf('blank.gif') === -1 && imageUrl.indexOf('no-image') === -1) {
      return 'background-image: url(\'' + imageUrl.replace(/'/g, "\\'") + '\'); background-size: cover; background-position: center;';
    }

    // PRIORITY 3: Single CSS variable color (from --color attribute on Groupmate swatches)
    // This is a real color, not a placeholder
    if (color && color !== 'null' && color !== 'transparent' && color.indexOf('#') === 0) {
      // Skip garbage placeholder values used by Groupmate for multi-color swatches
      var lower = color.toLowerCase().trim();
      var garbage = ['#fafafa', '#232535', '#cccccc', '#ffffff', '#fff', '#000000'];
      if (garbage.indexOf(lower) === -1) {
        return 'background-color: ' + color + ';';
      }
    }

    // PRIORITY 4: Multi-color from title (Black + Beige, Navy/Beige etc.)
    var isDouble = /[\/\+&]/.test(title) || /\s+and\s+/i.test(title);
    if (isDouble) {
      var dParts = title.split(/[\/\+&]|\s+and\s+/i).map(function (s) { return s.trim(); });
      var dc1 = getSwatchColor(dParts[0]);
      var dc2 = dParts[1] ? getSwatchColor(dParts[1]) : '';
      if (dc1 && dc2) return 'background: linear-gradient(90deg, ' + dc1 + ' 50%, ' + dc2 + ' 50%);';
      if (dc1) return 'background-color: ' + dc1 + ';';
      if (color) return 'background-color: ' + color + ';';
      return 'background-color: #c0c0c0;';
    }

    // PRIORITY 5: Title-based color lookup
    var sc = getSwatchColor(title);
    if (sc) return 'background-color: ' + sc + ';';

    // PRIORITY 6: Fallback color if valid
    if (color) return 'background-color: ' + color + ';';

    return 'background-color: #c0c0c0;';
  }

  function extractSwatchHtml(html, sourceHandle) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');

      // Strategy 1: Groupmate swatches — ONLY if more than 1 (actual group)
      var gmSwatches = doc.querySelectorAll('.gm_swatch_list .gm_item--swatch');
      if (gmSwatches.length > 1) {
        var html1 = '';
        gmSwatches.forEach(function (li) {
          var anchor = li.querySelector('a');
          if (!anchor) return;
          var href = anchor.getAttribute('href') || '';
          var handle = (
            anchor.getAttribute('data-preorder-handle') ||
            anchor.getAttribute('d-handle') ||
            (href.split('/products/')[1] || '').split('?')[0]
          ) || '';
          var title = anchor.getAttribute('data-gm-title') || anchor.getAttribute('title') || '';
          var isActive = handle === sourceHandle;
          var styleAttr = li.getAttribute('style') || '';
          var colorMatch = styleAttr.match(/--color\s*:\s*([^;]+)/);
          var color = colorMatch ? colorMatch[1].trim() : '';
          var imgDiv = li.querySelector('.gm_item_color');
          var imgEl = li.querySelector('img');
          var imageUrl = '';
          if (imgDiv) {
            var divStyle = imgDiv.getAttribute('style') || '';
            var divBgMatch = divStyle.match(/background-image\s*:\s*url\(['"]?([^'")]+)['"]?\)/);
            if (divBgMatch) {
              imageUrl = divBgMatch[1];
            }
          }
          if (!imageUrl && imgEl) {
            imageUrl = imgEl.getAttribute('src') ||
                       imgEl.getAttribute('data-src') ||
                       imgEl.getAttribute('data-lazy-src') ||
                       imgEl.getAttribute('data-original') || '';
          }
          if (imageUrl) {
            if (imageUrl.indexOf('//') === 0) imageUrl = 'https:' + imageUrl;
            if (imageUrl.indexOf('width=') !== -1) {
              imageUrl = imageUrl.replace(/width=\d+/, 'width=60');
            } else {
              imageUrl = imageUrl.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|\d+x)(\.(jpg|jpeg|png|gif|webp))/i, '_60x60$2');
            }
          }
          var bgStyle = buildBgStyle(imageUrl, color, title);
          html1 += '<li><a href="' + href + '"' +
            ' class="pc-color-circle' + (isActive ? ' is-active' : '') + '"' +
            ' title="' + escapeAttr(title) + '"' +
            ' style="' + bgStyle + '"' +
            ' data-product-handle="' + escapeAttr(handle) + '"' +
            ' data-source-type="groupmate"' +
            ' aria-label="' + escapeAttr(title) + '"></a></li>';
        });
        if (html1) return { html: html1, type: 'groupmate' };
      }

      return { html: '', type: 'none' };
    } catch (e) {
      return { html: '', type: 'error' };
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(s) { return escapeHtml(s); }

  function loadCardSwatches(card) {
    if (!card || __pcFetchedCards.has(card)) return;
    __pcFetchedCards.add(card);
    var ul = card.querySelector('.pc-color-circles');
    if (!ul) return;
    var handle = ul.getAttribute('data-source-handle');
    if (!handle) return;
    fetchProductPageSwatches(handle).then(function (result) {
      // Show circles ONLY if we have valid swatches (not just placeholder)
      if (result && result.html && result.html.indexOf('pc-color-circle') !== -1) {
        // Count actual circles in returned HTML
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = result.html;
        var circleCount = tempDiv.querySelectorAll('.pc-color-circle').length;
        if (circleCount >= 2) {
          // Real group/variants — show
          ul.innerHTML = result.html;
          ul.setAttribute('data-source-type', result.type);
          ul.style.visibility = 'visible';
          ul.style.minHeight = '';
          ul.style.margin = '';
        } else {
          // Only 1 swatch = solo product = hide
          ul.style.display = 'none';
        }
      } else {
        ul.style.display = 'none';
      }
    }).catch(function () {
      ul.style.display = 'none';
    });
  }

  // Fallback for theme editor: force load all cards after 1 second
  if (window.Shopify && Shopify.designMode) {
    setTimeout(function () {
      document.querySelectorAll('product-card.product-card').forEach(loadCardSwatches);
    }, 1000);
  }

  // Detect theme editor (Shopify.designMode === true in editor)
  var isThemeEditor = !!(window.Shopify && window.Shopify.designMode);

  if (isThemeEditor) {
    // ===== THEME EDITOR MODE: Force eager load all cards immediately =====
    function forceLoadAllCards() {
      document.querySelectorAll('product-card.product-card').forEach(function (c) {
        loadCardSwatches(c);
      });
    }

    // Initial load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(forceLoadAllCards, 300);
      });
    } else {
      setTimeout(forceLoadAllCards, 300);
    }

    // Re-scan every 1.5 seconds (theme editor adds/removes blocks dynamically)
    setInterval(forceLoadAllCards, 1500);

    // Re-scan on Shopify section reload events
    document.addEventListener('shopify:section:load', function () {
      setTimeout(forceLoadAllCards, 200);
    });
    document.addEventListener('shopify:section:reorder', function () {
      setTimeout(forceLoadAllCards, 200);
    });
    document.addEventListener('shopify:block:select', function () {
      setTimeout(forceLoadAllCards, 200);
    });

  } else     // Fallback for theme editor: force load all cards after 800ms
  if (window.Shopify && window.Shopify.designMode) {
    setTimeout(function () {
      document.querySelectorAll('product-card.product-card').forEach(loadCardSwatches);
    }, 800);
    // Also refresh on Shopify section reload
    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () {
        __pcFetchedCards = new WeakSet();
        document.querySelectorAll('product-card.product-card').forEach(loadCardSwatches);
      }, 300);
    });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadCardSwatches(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });

    function observeAllCards() {
      document.querySelectorAll('product-card.product-card').forEach(function (c) {
        if (!__pcFetchedCards.has(c)) io.observe(c);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAllCards);
    } else {
      observeAllCards();
    }
    setInterval(observeAllCards, 2000);
  } else {
    // ===== FALLBACK: Old browsers, load all after delay =====
    setTimeout(function () {
      document.querySelectorAll('product-card.product-card').forEach(loadCardSwatches);
    }, 500);
  }

  /* ============ COLOR CIRCLE CLICK ============ */
  document.addEventListener('click', function (e) {
    var circle = e.target.closest('.pc-color-circle');
    if (!circle) return;
    e.preventDefault(); e.stopPropagation();
    var wrapper = pcFindWrapper(circle);
    var card = wrapper ? wrapper.querySelector('product-card.product-card') : null;
    if (!wrapper || !card) return;
    var list = circle.closest('.pc-color-circles');
    list.querySelectorAll('.pc-color-circle').forEach(function (c) { c.classList.remove('is-active'); });
    circle.classList.add('is-active');
    var handle = circle.dataset.productHandle;
    var sourceType = circle.dataset.sourceType;
    var colorValue = circle.dataset.colorValue;
    if (sourceType === 'variant' && colorValue) {
      updateCardFromVariantColor(wrapper, card, handle, colorValue);
    } else if (handle) {
      updateCardFullSync(wrapper, card, handle);
    }
  }, true);

  function updateCardFullSync(wrapper, card, handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    wrapper.classList.add('pc-color-loading');
    fetch(root + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var primaryImg = card.querySelector('.product-card__image--primary');
        if (primaryImg && product.featured_image) { primaryImg.src = product.featured_image; primaryImg.srcset = ''; }
        var secondaryImg = card.querySelector('.product-card__image--secondary');
        if (secondaryImg && product.images && product.images.length > 1) { secondaryImg.src = product.images[1]; secondaryImg.srcset = ''; }
        var mediaLink = card.querySelector('.product-card__media');
        if (mediaLink) mediaLink.href = '/products/' + product.handle;
        var titleLink = card.querySelector('.product-title');
        if (titleLink) { titleLink.href = '/products/' + product.handle; titleLink.innerHTML = (product.title || '').replace(/\|/g, '<br>'); }
        updatePriceDisplay(card, product);
        var qsBtn = card.querySelector('.pc-quick-shop-btn');
        if (qsBtn) qsBtn.dataset.productHandle = product.handle;
        var actionRow = pcFindActionRow(wrapper);
        if (actionRow) {
          actionRow.dataset.productHandle = product.handle;
          var atcBtn = actionRow.querySelector('.pc-atc-btn');
          if (atcBtn) atcBtn.dataset.productHandle = product.handle;
          rebuildSizeDropdown(actionRow, product);
        }
        card.setAttribute('handle', product.handle);
        wrapper.dataset.cardHandle = product.handle;
        wrapper.classList.remove('pc-color-loading');
      })
      .catch(function () { wrapper.classList.remove('pc-color-loading'); });
  }

  function updateCardFromVariantColor(wrapper, card, handle, colorValue) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    wrapper.classList.add('pc-color-loading');
    fetch(root + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var colorIdx = -1;
        for (var k = 0; k < product.options.length; k++) {
          var name = (typeof product.options[k] === 'string' ? product.options[k] : product.options[k].name || '').toLowerCase();
          if (name.indexOf('color') !== -1 || name.indexOf('colour') !== -1) { colorIdx = k; break; }
        }
        if (colorIdx === -1) { wrapper.classList.remove('pc-color-loading'); return; }
        var matchingVariant = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].options[colorIdx] === colorValue && product.variants[i].available) { matchingVariant = product.variants[i]; break; }
        }
        if (!matchingVariant) {
          for (var j = 0; j < product.variants.length; j++) {
            if (product.variants[j].options[colorIdx] === colorValue) { matchingVariant = product.variants[j]; break; }
          }
        }
        if (matchingVariant) {
          var primaryImg = card.querySelector('.product-card__image--primary');
          if (primaryImg && matchingVariant.featured_image && matchingVariant.featured_image.src) { primaryImg.src = matchingVariant.featured_image.src; primaryImg.srcset = ''; }
          updatePriceDisplay(card, product, matchingVariant);
        }
        var actionRow = pcFindActionRow(wrapper);
        if (actionRow) rebuildSizeDropdownForColor(actionRow, product, colorIdx, colorValue);
        wrapper.classList.remove('pc-color-loading');
      })
      .catch(function () { wrapper.classList.remove('pc-color-loading'); });
  }

  function updatePriceDisplay(card, product, variant) {
    var v = variant || product.variants.find(function (x) { return x.available; }) || product.variants[0];
    if (!v) return;
    var priceContainer = card.querySelector('.price-list, .product-card__info .price-list');
    if (!priceContainer) return;
    var symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'ZAR') ? 'R' : '$';
    var suffix = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active && window.Shopify.currency.active !== 'ZAR') ? ' ' + window.Shopify.currency.active : '';
    var priceHtml = '<sale-price class="text-on-background">' + symbol + (v.price / 100).toFixed(2) + suffix + '</sale-price>';
    if (v.compare_at_price && v.compare_at_price > v.price) {
      priceHtml = '<compare-at-price class="text-subdued"><s>' + symbol + (v.compare_at_price / 100).toFixed(2) + suffix + '</s></compare-at-price>' + priceHtml;
    }
    priceContainer.innerHTML = priceHtml;
  }

  function findSizeOptionIndex(product) {
    for (var i = 0; i < product.options.length; i++) {
      var name = (typeof product.options[i] === 'string' ? product.options[i] : product.options[i].name || '').toLowerCase();
      if (name === 'size' || name === 'sizes' || name.indexOf('size') !== -1) return i;
    }
    return -1;
  }

  // Fallback for ZAR formatting
  function rebuildSizeDropdown(actionRow, product) {
    var sizeIdx = findSizeOptionIndex(product);
    var dropdownMenu = actionRow.querySelector('.pc-size-dropdown-menu');
    var dropdownLabel = actionRow.querySelector('.pc-size-dropdown-selected');
    var dropdown = actionRow.querySelector('.pc-size-dropdown');
    if (sizeIdx === -1 || !dropdownMenu) return;
    var seen = {}; var sizes = [];
    product.variants.forEach(function (v) { var s = v.options[sizeIdx]; if (s && !seen[s]) { seen[s] = true; sizes.push(s); } });
    var html = '';
    sizes.forEach(function (sz) {
      var bestV = null, fallbackV = null;
      product.variants.forEach(function (v) { if (v.options[sizeIdx] === sz) { if (!fallbackV) fallbackV = v; if (v.available && !bestV) bestV = v; } });
      var isAvail = !!bestV;
      var vid = (bestV || fallbackV).id;
      html += '<li><button type="button" class="pc-size-option' + (isAvail ? '' : ' is-sold-out') + '" data-variant-id="' + vid + '" data-size="' + escapeAttr(sz) + '" role="option" aria-selected="false"' + (isAvail ? '' : ' disabled aria-disabled="true"') + '>';
      html += '<span class="pc-size-option-label">' + escapeHtml(sz) + '</span>';
      if (!isAvail) html += '<span class="pc-size-option-status">Sold out</span>';
      html += '</button></li>';
    });
    dropdownMenu.innerHTML = html;
    if (dropdownLabel) dropdownLabel.textContent = 'Select size';
    if (dropdown) dropdown.classList.remove('is-open');
  }

  function rebuildSizeDropdownForColor(actionRow, product, colorIdx, colorValue) {
    var sizeIdx = findSizeOptionIndex(product);
    var dropdownMenu = actionRow.querySelector('.pc-size-dropdown-menu');
    var dropdownLabel = actionRow.querySelector('.pc-size-dropdown-selected');
    var dropdown = actionRow.querySelector('.pc-size-dropdown');
    if (sizeIdx === -1 || !dropdownMenu) return;
    var filtered = product.variants.filter(function (v) { return v.options[colorIdx] === colorValue; });
    var seen = {}; var sizes = [];
    filtered.forEach(function (v) { var s = v.options[sizeIdx]; if (s && !seen[s]) { seen[s] = true; sizes.push(s); } });
    var html = '';
    sizes.forEach(function (sz) {
      var bestV = null, fallbackV = null;
      filtered.forEach(function (v) { if (v.options[sizeIdx] === sz) { if (!fallbackV) fallbackV = v; if (v.available && !bestV) bestV = v; } });
      var isAvail = !!bestV;
      var vid = (bestV || fallbackV).id;
      html += '<li><button type="button" class="pc-size-option' + (isAvail ? '' : ' is-sold-out') + '" data-variant-id="' + vid + '" data-size="' + escapeAttr(sz) + '" role="option" aria-selected="false"' + (isAvail ? '' : ' disabled aria-disabled="true"') + '>';
      html += '<span class="pc-size-option-label">' + escapeHtml(sz) + '</span>';
      if (!isAvail) html += '<span class="pc-size-option-status">Sold out</span>';
      html += '</button></li>';
    });
    dropdownMenu.innerHTML = html;
    if (dropdownLabel) dropdownLabel.textContent = 'Select size';
    if (dropdown) dropdown.classList.remove('is-open');
  }

  function addToCart(variantId, atcBtn, wrapper, actionRow) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function (r) { if (!r.ok) return r.json().then(function (err) { throw err; }); return r.json(); })
    .then(function () { return refreshDrawer(root); })
    .then(function () {
      atcBtn.classList.remove('is-loading');
      atcBtn.textContent = '✓ Added';
      atcBtn.style.backgroundColor = '#2e7d32';
      openDrawer();
      updateCount(root);
      setTimeout(function () {
        atcBtn.textContent = 'Add to cart';
        atcBtn.style.backgroundColor = '';
        if (actionRow) {
          var selSize = actionRow.querySelector('.pc-size-option.is-selected');
          if (selSize) { selSize.classList.remove('is-selected'); selSize.setAttribute('aria-selected', 'false'); }
          var label = actionRow.querySelector('.pc-size-dropdown-selected');
          if (label) label.textContent = 'Select size';
        }
      }, 1500);
    })
    .catch(function (err) {
      atcBtn.classList.remove('is-loading');
      atcBtn.textContent = 'Error';
      atcBtn.style.backgroundColor = '#c62828';
      console.error('ATC error:', err);
      setTimeout(function () { atcBtn.textContent = 'Add to cart'; atcBtn.style.backgroundColor = ''; }, 2000);
    });
  }

  function refreshDrawer(root) {
    return fetch(root + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newD = doc.querySelector('cart-drawer');
        var oldD = document.querySelector('cart-drawer');
        if (newD && oldD) { oldD.parentNode.replaceChild(newD, oldD); document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); }
      });
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer'); if (!d) return;
    if (typeof d.show === 'function') { try { d.show(); return; } catch(e){} }
    if (typeof d.open === 'function') { try { d.open(); return; } catch(e){} }
    d.setAttribute('open', ''); d.removeAttribute('hidden');
    var trig = document.querySelector('[aria-controls="cart-drawer"]');
    if (trig) trig.click();
  }

  function updateCount(root) {
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var els = document.querySelectorAll('[data-cart-count], .cart-count, .cart-link__bubble, .header__cart-count, .cart-icon-bubble, cart-count');
        els.forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-cart-count', cart.item_count); });
      });
  }
})();